import InputField from "../../../../components/generic/inputField";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "../../../../components/generic/edbutton/edButton";
import { useNavigate } from "react-router-dom";
import { alphaNumExp, pan } from "../../../../utils/regex";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { ILoginFlows, } from "@domains/features/LoginFlow/entities/CommonLoginData";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { ChooseAccountForLogin } from "../ClientUser/chooseAccntForLogin";
import { useSelector } from "react-redux";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { forgotPasswordState, handleNavigateUrl, loginScreenState, } from "../constant";
import SaveRoute from "../saveRoute";
import LoginHOC from "../LoginHOC";
import NewPassword from "./NewPassword";
import PasswordResetMsg from "./PasswordResetMsg";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
const inputfield = {
    name: "",
    pan: "",
};
const ForgotPassword = (props) => {
    const device = DeviceContext();
    const redirectUrlFromQueryParams = getQueryParameterName("redirectUrl");
    const [formData, setFormData] = useState(inputfield);
    const [accountType, setAccountType] = useState();
    const [screenState, setScreenState] = useState(forgotPasswordState.FORGOT_PASSWORD);
    const handleChange = (event) => {
        di.login.flushLoginError();
        setFormData(Object.assign(Object.assign({}, formData), { [event.currentTarget.name]: event.currentTarget.value.toUpperCase() }));
    };
    const [error, setError] = useState(inputfield);
    const validationError = (field, value) => {
        setError(Object.assign(Object.assign({}, error), { [field]: value }));
    };
    const { data: ClientGenOTP, loader: ClientGenOTPLoader, errorData: ClientGenOTPError, } = useSelector((state) => state.LoginFlow.ClientGenOTP);
    const navigate = useNavigate();
    const SubmitforgotPassword = () => {
        if (props.UserType == ILoginFlows.CLIENT) {
            let payload = {
                clientReq: {
                    pan: formData.pan,
                    accTyp: accountType,
                },
                userID: formData.name,
            };
            di.login.clientGenerateOTP(payload);
        }
    };
    const HandleDisable = () => {
        return (error.name.length > 0 ||
            error.pan.length > 0 ||
            formData.name.length <= 0 ||
            formData.pan.length <= 0 ||
            !accountType);
    };
    const updateScreenState = (state) => {
        setScreenState(state);
    };
    const handleScreens = () => {
        switch (screenState) {
            case forgotPasswordState.FORGOT_PASSWORD:
                return (React.createElement("div", { className: "forgotpassword-block  bg-white px-md-0 px-3 pt-2 pt-md-0" },
                    React.createElement("form", { id: "forgotPassword-form", onSubmit: (e) => {
                            e.preventDefault();
                        } },
                        React.createElement(Row, null,
                            (device === null || device === void 0 ? void 0 : device.isDesktop) ? ("") : (React.createElement(React.Fragment, null,
                                React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700 mt-4" }, "Forgot Password"))),
                            React.createElement(ChooseAccountForLogin, { noGridContainer: true, setAccountType: setAccountType, description: "Please choose which account you want to reset the password for" }),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-30" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.name, pattern: alphaNumExp, onBlur: (error, event) => {
                                        if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.name, highlightInputField: true, placeholder: "Enter your login ID", id: "name", name: "name", required: true, autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" })),
                            React.createElement(Col, { lg: 12, className: "d-flex justify-end" },
                                React.createElement(EdButton, { btnTyp: "link", className: "no_bg underline cursor d-flex justify-content-end DMSanM_14_500  txt-midnight-blue mt-2", onClick: () => {
                                        di.login.flushLoginError();
                                        if (props.helpFlowPopup) {
                                            props.helpFlowPopup(loginScreenState.FORGOT_LOGIN_ID);
                                        }
                                        else {
                                            navigate(handleNavigateUrl("/forgot-loginId", redirectUrlFromQueryParams), {
                                                replace: true,
                                            });
                                        }
                                    }, type: "button", value: "Forgot login ID?" })),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5" },
                                React.createElement(InputField, { type: "text", onChangeEvent: (e) => {
                                        validationError("pan", "");
                                        handleChange(e);
                                    }, pattern: pan, onBlur: (error, event) => {
                                        var _a, _b;
                                        if (((_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) > 0 && !error.pattern)
                                            validationError(event.target.name, "Please enter a valid PAN Number");
                                        else if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.pan, highlightInputField: true, defaultValue: formData.pan, placeholder: "Enter your PAN", id: "PAN", name: "pan", maxLength: 10, required: true, autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" }))),
                        !ClientGenOTPLoader && ClientGenOTPError.isOpen && (React.createElement(ErrorExclamation, { errorMessage: ClientGenOTPError.error.getErrorMessageOrErrMsg() })),
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5" },
                                React.createElement(EdButton, { value: "Next", className: "w-100", btnTyp: "midnight-blue", onClick: SubmitforgotPassword, disabled: HandleDisable() }))))));
            case forgotPasswordState.NEW_PASSWORD:
                return (
                // <h1>Forgot Password</h1>
                React.createElement(SaveRoute, { truthy: true, safePath: "/login" },
                    React.createElement(LoginHOC, { component: NewPassword, title: "Forgot Password", UserType: ILoginFlows.CLIENT, helpFlowPopup: updateScreenState, accountDetails: {
                            accTyp: accountType,
                            userID: formData.name,
                            pan: formData.pan,
                        } })));
            case forgotPasswordState.SUCCESS_STATE:
                return (React.createElement(PasswordResetMsg, { title: "Password Reset!", message: "Your password has been reset successfully.", helpFlowPopup: props.helpFlowPopup, redirectUrlFromQueryParams: redirectUrlFromQueryParams }));
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    useEffect(() => {
        if (screenState) {
            handleScreens();
        }
    }, [screenState]);
    React.useEffect(() => {
        if (!ClientGenOTPLoader && !ClientGenOTPError.isOpen) {
            if (ClientGenOTP.OTPSent) {
                updateScreenState(forgotPasswordState.NEW_PASSWORD);
            }
        }
    }, [ClientGenOTP, ClientGenOTPLoader, ClientGenOTPError]);
    useEffect(() => {
        di.login.flushLoginError();
    }, []);
    return React.createElement(React.Fragment, null, handleScreens());
};
export default ForgotPassword;
